export default {
  getUrlParam(param) {
    const internalParam = param.replace(/[[]/, `\\[`).replace(/[\]]/, `\\]`);
    const regex = new RegExp(`[?&]${internalParam}=([^&#]*)`);
    const results = regex.exec(window.location.search);
    return results === null ? `` : decodeURIComponent(results[1].replace(/\+/g, ` `));
  },
};
